import React from "react";
import styles from "./PeopleUI.module.css";
import { DEFAULT_WEEKLY_HOURS } from "../../../utils/costUtils";

const fmt = (n) => (Math.round(n * 10) / 10).toString();

// This week's booked hours against weekly capacity: amber from 85%, red when over.
export default function WeekBar({ booked, capacity }) {
  const hours = Number(booked) || 0;
  const cap = capacity == null ? DEFAULT_WEEKLY_HOURS : Number(capacity) || 0;
  const ratio = cap > 0 ? hours / cap : hours > 0 ? Infinity : 0;
  const tone = ratio > 1 ? styles.weekOver : ratio >= 0.85 ? styles.weekNear : "";
  return (
    <div className={`${styles.weekBar} ${tone}`} title={`${fmt(hours)} of ${fmt(cap)} hours booked this week`}>
      <span className={styles.weekLabel}>{fmt(hours)}/{fmt(cap)}h</span>
      <span className={styles.weekTrack}>
        <span className={styles.weekFill} style={{ width: `${Math.min(100, ratio * 100)}%` }} />
      </span>
    </div>
  );
}
